// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".discount-badge[data-v-26047609]{color:var(--discount-badge-color,var(--white));line-height:1em;padding:5px 8px 5px .5em;position:relative}.discount-badge .discount-svg[data-v-26047609]{fill:var(--discount-badge-bg,var(--primary));height:100%;left:0;position:absolute;top:0;width:100%;z-index:1}.discount-badge .discount-value[data-v-26047609]{font-weight:700;position:relative;z-index:2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
